export const courseDetailReportMock = {
    "courseWithGroups": true,
    "collaborator": [
        {
            "id": "cc454987-07cf-46e3-ad31-aba74ddb8b8d",
            "avatar_url": "https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fimg%2FavatarDefault.png?alt=media&token=8179edfc-4fd5-463d-8faa-74b3c1e2a5ee",
            "is_disabled": false,
            "created_at": "2024-10-09T19:42:04.439Z",
            "completed_at": null,
            "group_name": "Grupo 2",
            "progress": 0,
            "general_score": 0,
            "accreditation_qualtrics": null,
            "total_count": 23,
            "lessons": [],
            "modules": [],
            "course_state": "INACTIVE",
            "ou": "Engineering",
            "role": "Ingeniero de Software",
            "contribution_level": "Líder",
            "platform_state": "active",
            "full_name": "Admin Lapzo",
            "started_at": null
        },
        {
            "id": "e2fb012a-e69b-47c9-8b28-29a228c2e9f3",
            "avatar_url": "https://res.cloudinary.com/lernit/image/upload/v1637878337/Courses/pqj7rnvevrn9rtjpooct.jpg",
            "is_disabled": false,
            "created_at": "2023-09-20T22:49:49.474Z",
            "completed_at": null,
            "progress": 0,
            "general_score": 0,
            "accreditation_qualtrics": null,
            "total_count": 23,
            "lessons": [],
            "modules": [
                {
                    "name": "Gestión proactiva de riesgos: aprendiendo a prever y prevenir",
                    "index": 0,
                    "module": "7b5f65be-0fdf-465f-bc7e-b839e32d5a63",
                    "progress": 0
                },
                {
                    "name": "Consolidando aprendizajes",
                    "index": 1,
                    "module": "472091d9-449b-41ef-b19b-2fd41075c66b",
                    "progress": 0
                }
            ],
            "course_state": "INACTIVE",
            "ou": "Engineering",
            "role": "Ingeniero de Software",
            "contribution_level": "Líder",
            "platform_state": "active",
            "full_name": "Amy Manzo",
            "started_at": null
        },
        {
            "id": "6e2055b1-6f8e-43b6-9cd9-b6a8a235677d",
            "avatar_url": "https://res.cloudinary.com/lernit/image/upload/v1668100657/Courses/l9pwmxzx8yzsbqfefzta.jpg",
            "is_disabled": false,
            "created_at": "2023-09-20T22:49:49.474Z",
            "completed_at": null,
            "group_name": "Grupo 2",
            "progress": 0,
            "general_score": 0,
            "accreditation_qualtrics": null,
            "total_count": 23,
            "lessons": [],
            "modules": [
                {
                    "name": "Gestión proactiva de riesgos: aprendiendo a prever y prevenir",
                    "index": 0,
                    "module": "7b5f65be-0fdf-465f-bc7e-b839e32d5a63",
                    "progress": 0
                },
                {
                    "name": "Consolidando aprendizajes",
                    "index": 1,
                    "module": "472091d9-449b-41ef-b19b-2fd41075c66b",
                    "progress": 0
                }
            ],
            "course_state": "INACTIVE",
            "ou": "Engineering",
            "role": "Ingeniero de Software",
            "contribution_level": "Líder",
            "platform_state": "active",
            "full_name": "Andrea Arreola",
            "started_at": null
        },
        {
            "id": "3bf070ee-c65f-4199-a410-b8ed624bf6e1",
            "avatar_url": "https://res.cloudinary.com/lernit/image/upload/v1668120055/Courses/jrbmdfwyzlhybdthpkra.jpg",
            "is_disabled": false,
            "created_at": "2023-09-20T22:49:49.474Z",
            "completed_at": null,
            "group_name": "Grupo 2",
            "progress": 0,
            "general_score": 0,
            "accreditation_qualtrics": null,
            "total_count": 23,
            "lessons": [],
            "modules": [
                {
                    "name": "Consolidando aprendizajes",
                    "index": 1,
                    "module": "472091d9-449b-41ef-b19b-2fd41075c66b",
                    "progress": 33
                },
                {
                    "name": "Gestión proactiva de riesgos: aprendiendo a prever y prevenir",
                    "index": 0,
                    "module": "7b5f65be-0fdf-465f-bc7e-b839e32d5a63",
                    "progress": 60
                }
            ],
            "course_state": "INACTIVE",
            "ou": "Engineering",
            "role": "Ingeniero de Software",
            "contribution_level": "Líder",
            "platform_state": "active",
            "full_name": "Andrea Betancourt",
            "started_at": null
        },
        {
            "id": "c8c902b9-4918-465f-ba28-0bfeb807671a",
            "avatar_url": "https://res.cloudinary.com/lernit/image/upload/v1640732722/Courses/aoiu2qmoocwtbbvwcr49.png",
            "is_disabled": false,
            "created_at": "2023-09-20T22:49:49.474Z",
            "completed_at": null,
            "group_name": "Grupo 1",
            "progress": 0,
            "general_score": 0,
            "accreditation_qualtrics": null,
            "total_count": 23,
            "lessons": [],
            "modules": [
                {
                    "name": "Gestión proactiva de riesgos: aprendiendo a prever y prevenir",
                    "index": 0,
                    "module": "7b5f65be-0fdf-465f-bc7e-b839e32d5a63",
                    "progress": 0
                },
                {
                    "name": "Consolidando aprendizajes",
                    "index": 1,
                    "module": "472091d9-449b-41ef-b19b-2fd41075c66b",
                    "progress": 0
                }
            ],
            "course_state": "INACTIVE",
            "ou": "Engineering",
            "role": "Ingeniero de Software",
            "contribution_level": "Líder",
            "platform_state": "active",
            "full_name": "Andrea Pereda",
            "started_at": null
        },
        {
            "id": "d8635dc5-9329-4a10-a96b-03980761559d",
            "avatar_url": "https://res.cloudinary.com/lernit/image/upload/v1666807768/Courses/zghp1xzk1dxjpszta5nh.jpg",
            "is_disabled": false,
            "created_at": "2023-09-20T22:49:49.474Z",
            "completed_at": null,
            "group_name": "Grupo 1",
            "progress": 0,
            "general_score": 0,
            "accreditation_qualtrics": null,
            "total_count": 23,
            "lessons": [],
            "modules": [
                {
                    "name": "Consolidando aprendizajes",
                    "index": 1,
                    "module": "472091d9-449b-41ef-b19b-2fd41075c66b",
                    "progress": 0
                },
                {
                    "name": "Gestión proactiva de riesgos: aprendiendo a prever y prevenir",
                    "index": 0,
                    "module": "7b5f65be-0fdf-465f-bc7e-b839e32d5a63",
                    "progress": 0
                }
            ],
            "course_state": "INACTIVE",
            "ou": "Engineering",
            "role": "Ingeniero de Software",
            "contribution_level": "Líder",
            "platform_state": "active",
            "full_name": "Andrea Reyes",
            "started_at": null
        },
        {
            "id": "660fa354-45c6-4547-b66c-f5697a956350",
            "avatar_url": "https://res.cloudinary.com/lernit/image/upload/v1677709531/Courses/nwveqdtfoe1ba9my6uwq.jpg",
            "is_disabled": false,
            "created_at": "2023-09-20T22:49:49.474Z",
            "completed_at": null,
            "group_name": "Grupo 1",
            "progress": 0,
            "general_score": 0,
            "accreditation_qualtrics": null,
            "total_count": 23,
            "lessons": [],
            "modules": [
                {
                    "name": "Gestión proactiva de riesgos: aprendiendo a prever y prevenir",
                    "index": 0,
                    "module": "7b5f65be-0fdf-465f-bc7e-b839e32d5a63",
                    "progress": 0
                },
                {
                    "name": "Consolidando aprendizajes",
                    "index": 1,
                    "module": "472091d9-449b-41ef-b19b-2fd41075c66b",
                    "progress": 0
                }
            ],
            "course_state": "INACTIVE",
            "ou": "Engineering",
            "role": "Ingeniero de Software",
            "contribution_level": "Líder",
            "platform_state": "active",
            "full_name": "Are Velarde",
            "started_at": null
        },
        {
            "id": "1265bab7-fdd3-4d4c-b75b-b0d875838a8e",
            "avatar_url": "https://res.cloudinary.com/lernit/image/upload/v1653429346/Courses/yyr3rnbrbz0qb1roooyb.jpg",
            "is_disabled": false,
            "created_at": "2023-11-13T17:43:27.297Z",
            "completed_at": null,
            "group_name": "Grupo 1",
            "progress": 0,
            "general_score": 0,
            "accreditation_qualtrics": null,
            "total_count": 23,
            "lessons": [],
            "modules": [
                {
                    "name": "Gestión proactiva de riesgos: aprendiendo a prever y prevenir",
                    "index": 0,
                    "module": "7b5f65be-0fdf-465f-bc7e-b839e32d5a63",
                    "progress": 0
                },
                {
                    "name": "Consolidando aprendizajes",
                    "index": 1,
                    "module": "472091d9-449b-41ef-b19b-2fd41075c66b",
                    "progress": 0
                }
            ],
            "course_state": "INACTIVE",
            "ou": "Engineering",
            "role": "Ingeniero de Software",
            "contribution_level": "Líder",
            "platform_state": "active",
            "full_name": "Aydee Quispe",
            "started_at": null
        },
        {
            "id": "83233373-3596-4315-b7c0-b571a71454a7",
            "avatar_url": "https://res.cloudinary.com/lernit/image/upload/v1648081581/Courses/t6s6hxmobtr3hmlmuldq.jpg",
            "is_disabled": false,
            "created_at": "2023-09-20T22:49:49.474Z",
            "completed_at": null,
            "group_name": "Grupo 1",
            "progress": 0,
            "general_score": 0,
            "accreditation_qualtrics": null,
            "total_count": 23,
            "lessons": [],
            "modules": [
                {
                    "name": "Gestión proactiva de riesgos: aprendiendo a prever y prevenir",
                    "index": 0,
                    "module": "7b5f65be-0fdf-465f-bc7e-b839e32d5a63",
                    "progress": 0
                },
                {
                    "name": "Consolidando aprendizajes",
                    "index": 1,
                    "module": "472091d9-449b-41ef-b19b-2fd41075c66b",
                    "progress": 0
                }
            ],
            "course_state": "INACTIVE",
            "ou": "Engineering",
            "role": "Ingeniero de Software",
            "contribution_level": "Líder",
            "platform_state": "active",
            "full_name": "Daniel Sandoval",
            "started_at": null
        },
        {
            "id": "e3461ca1-a4dd-4109-aae3-b1564dc27014",
            "avatar_url": "https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fimg%2FavatarDefault.png?alt=media&token=8179edfc-4fd5-463d-8faa-74b3c1e2a5ee",
            "is_disabled": false,
            "created_at": "2024-10-10T20:10:32.114Z",
            "completed_at": null,
            "group_name": "Grupo 2",
            "progress": 0,
            "general_score": 0,
            "accreditation_qualtrics": null,
            "total_count": 23,
            "lessons": [],
            "modules": [],
            "course_state": "INACTIVE",
            "ou": "Engineering",
            "role": "Ingeniero de Software",
            "contribution_level": "Líder",
            "platform_state": "active",
            "full_name": "Diego Lanesan",
            "started_at": null
        }
    ],
    "collaboratorCount": 23,
    "coursesModules": [
        {
            "module": "7b5f65be-0fdf-465f-bc7e-b839e32d5a63",
            "index": 0,
            "name": "Gestión proactiva de riesgos: aprendiendo a prever y prevenir"
        },
        {
            "module": "472091d9-449b-41ef-b19b-2fd41075c66b",
            "index": 1,
            "name": "Consolidando aprendizajes"
        }
    ],
    "coursesLessons": []
}